import MerchantInvoices from "../symbols/getMerchantInvoices";
import { HttpRequestPost } from "../../service";
const getMerchantInvoicesAction = () => ({
  type: MerchantInvoices.MERCHANT_INVOICES,
});
const getMerchantInvoicesSuccessAction = (data: any) => ({
  type: MerchantInvoices.MERCHANT_INVOICES_SUCCESS,
  payload: data,
});
const getMerchantInvoicesFailureAction = (data: any) => ({
  type: MerchantInvoices.MERCHANT_INVOICES_FAILURE,
  payload: data,
});
const clearMerchantInvoicesAction = () => ({
  type: MerchantInvoices.CLEAR_MERCHANT_INVOICES,
});
interface GetMerchantInvoicesRequestModelFilter {
  DateFrom?: Date;
  DateTo?: Date;
  Merchants?: string[];
  Shops?: string[];
  InvoiceType?: {
    TradeKartFee?: boolean;
    TradeKartCollect?: boolean;
    Shop?: boolean;
  };

}
interface GetMerchantInvoicesRequestModel {
  Query?: string;
  Filter?: GetMerchantInvoicesRequestModelFilter;
  Size: number;
  Page: number;

}
export function getMerchantInvoices(data: GetMerchantInvoicesRequestModel, callback?: (resp?: any) => void) {
  return (dispatch: any) => {
    dispatch(getMerchantInvoicesAction());
    HttpRequestPost(
      `/merchant/invoices`,
      dispatch,
      getMerchantInvoicesSuccessAction,
      getMerchantInvoicesFailureAction,
      true,
      data,
      callback
    );
  };
}

export function clearAdminInvoices() {
  return (dispatch: any) => {
    dispatch(clearMerchantInvoicesAction());
  };
}
